import request from '@/utils/request'
const api = {
    login:'/sso/login', //登录
    listEngineer:'/global/listEngineer', //获取工程
    orgList:'/engineer/list', //获取工程
    user:'/org/getUser',
    userList:'/org/userList',
    documentFileMove:'/org/moveOrg', //文档管理文件移动
    getListLikePid:'/org/likePath',//组织机构树
    organizationList:'/org/userList',//组织机构列表数据
    addUserView:'org/addUserOrgView',//添加组织机构人员
    addOrganizationUsers:'/org/addOrganizationUsers',
    delOrganizationUsers:'/org/delOrganizationUsers',
    getOrgData:'org/getOrgData',
    addOrganization:'org/addOrganization',
    getEngineerList:'org/getEngineerList',
    updateOrganization:'org/updateOrganization',
    delOrganization:'org/delOrganization',
    dataAuthorizationView:'org/dataAuthorizationView',
    dataAuthorizationAllEngView:'org/dataAuthorizationAllEngView',
    dataAuthorizationUserView:'org/dataAuthorizationUserView',
    addOrganizationRole:'org/addOrganizationRole',
    clearOrganizationRole:'org/clearOrganizationRole',
}
// 获取当前时间
export function getCurrentTime () {
    const val = new Date();
    const y = val.getFullYear();
    const m = (val.getMonth() + 1).toString().padStart(2, "0");
    const d = val
      .getDate()
      .toString()
      .padStart(2, "0");
    const h = val
      .getHours()
      .toString()
      .padStart(2, "0");
    const mi = val
      .getMinutes()
      .toString()
      .padStart(2, "0");
    const s = val
      .getSeconds()
      .toString()
      .padStart(2, "0");
    return `${y}-${m}-${d} ${h}:${mi}:${s}`;
  }
  //登录
 export function loginSystem (parameter) {
    return request({
      url: api.login,
      method: 'get',
      params: parameter,
    //   withCredentials:true
    })
  }
  //获取工程
  export function getListEngineer (parameter) {
    return request({
      url: api.listEngineer,
      method: 'get',
      params: parameter
    })
  }
   //获取组织
   export function getOrgList (parameter) {
    return request({
      url: api.orgList,
      method: 'get',
      params: parameter
    })
  }
  //获取用户
  export function getUser (parameter) {
    return request({
      url: api.user,
      method: 'get',
      params: parameter
    })
  }
  //获取用户列表
  export function getUserList (parameter) {
    return request({
      url: api.userList,
      method: 'get',
      params: parameter
    })
  }

  //组织机构树
 export function getListLikePid (parameter) {
  return request({
    url: api.getListLikePid,
    method: 'get',
    params: parameter
  })
}

 //用户列表
 export function getOrganizationList (parameter) {
  return request({
    url: api.organizationList,
    method: 'get',
    params: parameter
  })
}

 //添加人员页面
 export function addUserViewApi (parameter) {
  return request({
    url: api.addUserView,
    method: 'get',
    params: parameter
  })
}

 //添加组织人员页面
 export function addOrganizationUsersApi (parameter) {
  return request({
    url: api.addOrganizationUsers,
    method: 'post',
    params: parameter
  })
}

export function delOrganizationUsersApi (parameter) {
  return request({
    url: api.delOrganizationUsers,
    method: 'post',
    params: parameter
  })
}

export function getOrgDataApi (parameter) {
  return request({
    url: api.getOrgData,
    method: 'get',
    params: parameter
  })
}

export function addOrganizationApi (parameter) {
  return request({
    url: api.addOrganization,
    method: 'post',
    params: parameter
  })
}

// 获取当前日期
export function getCurrentDay () {
  const val = new Date();
  const y = val.getFullYear();
  const m = (val.getMonth() + 1).toString().padStart(2, "0");
  const d = val
    .getDate()
    .toString()
    .padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function getEngineerListApi (parameter) {
  return request({
    url: api.getEngineerList,
    method: 'get',
    params: parameter
  })
}

export function updateOrganizationApi (parameter) {
  return request({
    url: api.updateOrganization,
    method: 'post',
    params: parameter
  })
}

export function delOrganizationApi (parameter) {
  return request({
    url: api.delOrganization,
    method: 'post',
    params: parameter
  })
}

export function dataAuthorizationViewApi (parameter) {
  return request({
    url: api.dataAuthorizationView,
    method: 'get',
    params: parameter
  })
}

// 数据授权页面（所有工程的组织机构，按工程分层）
export function dataAuthorizationAllEngViewApi (parameter) {
  return request({
    url: api.dataAuthorizationAllEngView,
    method: 'get',
    params: parameter
  })
}

// 查询用户已配置的数据授权
export function dataAuthorizationUserViewApi (parameter) {
  return request({
    url: api.dataAuthorizationUserView,
    method: 'get',
    params: parameter
  })
}

export function addOrganizationRoleApi (parameter) {
  return request({
    url: api.addOrganizationRole,
    method: 'get',
    params: parameter
  })
}

export function clearOrganizationRoleApi (parameter) {
  return request({
    url: api.clearOrganizationRole,
    method: 'get',
    params: parameter
  })
}
//文档管库移动文件
export function getDocumentFileMove (parameter) {
  return request({
    url: api.documentFileMove,
    method: 'post',
    params: parameter
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js